import { render, staticRenderFns } from "./TeamHome.vue?vue&type=template&id=b01d6266&"
import script from "./TeamHome.vue?vue&type=script&lang=js&"
export * from "./TeamHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports